import React from "react";
import { SwimmerPreviewTable } from "../../../swimmers/components/SwimmerPreviewTable/SwimmerPreviewTable";
import { SwimmerPreviewFilter } from "../../../swimmers/components/SwimmerPreviewFilter/SwimmerPreviewFilter";
import { useSwimmersPreviewTab } from "./useSwimmersPreviewTab";
import { ResourceTab } from "../../../../shared/components/layout/ResourceTab";

export const SwimmersPreviewTab: React.FC<ReturnType<typeof useSwimmersPreviewTab>> = (
  props
) => {
  const {
    swimmersResource,
    buildingOptions,
    handleEditSwimmer,
    handleDeleteSwimmer,
  } = props;

  return (
    <>
      <ResourceTab
        resource={swimmersResource}
        filtersComponent={
          <SwimmerPreviewFilter
            lifeguardName={swimmersResource.filters.lifeguard_name}
            buildingId={swimmersResource.filters.building_id}
            startDate={swimmersResource.filters.start_date}
            endDate={swimmersResource.filters.end_date}
            buildingOptions={buildingOptions}
            onLifeguardNameChange={(v) =>
              swimmersResource.handleFilterChange("lifeguard_name", v)
            }
            onBuildingIdChange={(v) =>
              swimmersResource.handleFilterChange("building_id", v)
            }
            onStartDateChange={(v) =>
              swimmersResource.handleFilterChange("start_date", v)
            }
            onEndDateChange={(v) =>
              swimmersResource.handleFilterChange("end_date", v)
            }
            onApplyFilters={swimmersResource.applyFilters}
            onClearFilters={swimmersResource.resetFilters}
            onRefresh={swimmersResource.refetch}
            isRefreshing={swimmersResource.isFetching}
          />
        }
        tableComponent={
          <SwimmerPreviewTable
            swimmersData={swimmersResource.data!}
            isLoading={swimmersResource.isLoading}
            isError={swimmersResource.isError}
            page={swimmersResource.page}
            pageSize={swimmersResource.pageSize}
            onPageChange={swimmersResource.handlePageChange}
            onPageSizeChange={swimmersResource.handlePageSizeChange}
            onEditSwimmer={handleEditSwimmer}
            onDeleteSwimmer={handleDeleteSwimmer}
            showCellBorders
          />
        }
        emptyStateMessage="No hay bañistas para mostrar."
      />
    </>
  );
};
